import { getLocale } from "../runtime";

const sv_oncart = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `på varukorgen`
};

const oncart = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_oncart(inputs)
	return "onCart";
};

export { oncart as "onCart" };